import React, { useState, useEffect } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import Link from '@material-ui/core/Link';
import Button from '@material-ui/core/Button';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Grow from '@material-ui/core/Grow';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import ArrowDropDown from '@material-ui/icons/ArrowDropDown';
import Popper from '@material-ui/core/Popper';
import Paper from '@material-ui/core/Paper';
import { Badge } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import cx from 'classnames';
// import PatientChartConsultNotes from '../PatientChartConsultNotes';
import { CurrentUserConsumer } from '../../contexts/CurrentUserContext';
// import { CurrentPatientConsumer } from 'contexts/CurrentPatientContext';
// import CurrentPatientContext from 'contexts/CurrentPatientContext';
import Covid19Header from '../Covid19Header';
import './styles.css';

function PublicNavigation(props) {
  const {
    onLogout,
    context,
    commonCount,
    getCommonCount,
    attemptToFetchCurrentUser,
    classes: {
      navigation,
      toolbar,
      logoImage,
      contents,
      headerLink,
      headerLinkWithIcon,
      button,
      desktopOnlyLink,
      menuList,
      menuItem,
    },
  } = props;

  const [aboutMenuAnchorEl, setAboutMenuAnchorEl] = useState(null);
  const [accountMenuAnchorEl, setAccountMenuAnchorEl] = useState(null);
  const [actionsMenuAnchorEl, setActionsMenuAnchorEl] = useState(null);
  const [counts, setCounts] = useState(0);
  const findLocation = useLocation();
  //const findHistory = useHistory();

  /**
   * Get total message Count in context props
   */
  useEffect(() => {
    getCommonCount && getCommonCount();
  }, [findLocation.pathname]);

  const aboutMenuOpen = event => {
    setAboutMenuAnchorEl(event.currentTarget);
  };

  const aboutMenuClose = () => {
    setAboutMenuAnchorEl(null);
  };

  const accountMenuOpen = event => {
    setAccountMenuAnchorEl(event.currentTarget);
  };

  const accountMenuClose = () => {
    setAccountMenuAnchorEl(null);
  };

  const actionsMenuOpen = event => {
    setActionsMenuAnchorEl(event.currentTarget);
  };

  const actionsMenuClose = () => {
    setActionsMenuAnchorEl(null);
  };

  return (
    <CurrentUserConsumer>
      {/* <CurrentPatientConsumer> */}
      {({ currentUser }) => (
        <>
          <AppBar
            position="sticky"
            className={navigation}
            style={{ background: 'white' }}
          >
            <div className="fullWidHeader">
              <Toolbar className={toolbar}>
                <div className="mainHeader">
                  <Link href={process.env.REACT_APP_HOMEPAGE_URL}>
                    <img
                      src={process.env.PUBLIC_URL + '/images/qwellLogo.jpg'}
                      alt={'Qwell Logo'}
                      className={logoImage}
                    />
                  </Link>
                </div>

                <div className="menuNav">
                  <div className={contents}>
                    <Link
                      href={process.env.REACT_APP_HOMEPAGE_URL}
                      className={cx(headerLink, desktopOnlyLink)}
                    >
                      Home
                    </Link>

                    <Link
                      aria-owns={aboutMenuAnchorEl ? 'about-menu' : undefined}
                      aria-haspopup="true"
                      className={cx(
                        headerLink,
                        headerLinkWithIcon,
                        desktopOnlyLink
                      )}
                      onClick={aboutMenuOpen}
                    >
                      About
                      <ArrowDropDown />
                    </Link>

                    {currentUser ? (
                      <Link
                        aria-owns={
                          accountMenuAnchorEl ? 'account-menu' : undefined
                        }
                        aria-haspopup="true"
                        className={cx(headerLink, headerLinkWithIcon)}
                        onClick={accountMenuOpen}
                      >
                        My Account
                        <ArrowDropDown />
                      </Link>
                    ) : (
                      <Link
                        component={RouterLink}
                        to="/login"
                        className={headerLink}
                      >
                        Login / Sign Up
                      </Link>
                    )}
                    {currentUser ? (
                      <>
                        {commonCount > 0 ? (
                          <Badge
                            badgeContent={commonCount}
                            className="count-badge"
                          >
                            <Link
                              component={RouterLink}
                              to="/patientConsultNotes"
                              className={headerLink}
                            >
                              Messages
                            </Link>
                          </Badge>
                        ) : (
                          <Link
                            component={RouterLink}
                            to="/patientConsultNotes"
                            className={headerLink}
                          >
                            Messages
                          </Link>
                        )}
                      </>
                    ) : null}

                    <div className={currentUser ? 'bkAppointBtn' : 'BtnLogIn'}>
                      <Button
                        href={process.env.REACT_APP_HOMEPAGE_URL}
                        className={button}
                      >
                        Book Appointment
                      </Button>
                    </div>

                    <Popper
                      open={!!aboutMenuAnchorEl}
                      anchorEl={aboutMenuAnchorEl}
                      transition
                      disablePortal
                    >
                      {({ TransitionProps }) => (
                        <Grow
                          id="about-menu"
                          {...TransitionProps}
                          style={{ transformOrigin: 'bottom' }}
                        >
                          <Paper>
                            <ClickAwayListener onClickAway={aboutMenuClose}>
                              <MenuList className={menuList}>
                                <MenuItem>
                                  <Link
                                    href={
                                      process.env.REACT_APP_HOMEPAGE_URL +
                                      '/about/'
                                    }
                                    target="_blank"
                                    className={menuItem}
                                  >
                                    About Qwell
                                  </Link>
                                </MenuItem>

                                <MenuItem>
                                  <Link
                                    href={
                                      process.env.REACT_APP_HOMEPAGE_URL +
                                      '/for-providers/'
                                    }
                                    target="_blank"
                                    className={menuItem}
                                  >
                                    For Providers
                                  </Link>
                                </MenuItem>

                                <MenuItem>
                                  <Link
                                    href={
                                      process.env.REACT_APP_HOMEPAGE_URL +
                                      '/blog/'
                                    }
                                    target="_blank"
                                    className={menuItem}
                                  >
                                    Blog
                                  </Link>
                                </MenuItem>

                                <MenuItem>
                                  <Link
                                    href={
                                      process.env.REACT_APP_HOMEPAGE_URL +
                                      '/press/'
                                    }
                                    target="_blank"
                                    className={menuItem}
                                  >
                                    In the news
                                  </Link>
                                </MenuItem>
                              </MenuList>
                            </ClickAwayListener>
                          </Paper>
                        </Grow>
                      )}
                    </Popper>

                    <Popper
                      open={!!accountMenuAnchorEl}
                      anchorEl={accountMenuAnchorEl}
                      transition
                      disablePortal
                    >
                      {({ TransitionProps }) => (
                        <Grow
                          id="account-menu"
                          {...TransitionProps}
                          style={{ transformOrigin: 'bottom' }}
                        >
                          <Paper>
                            <ClickAwayListener onClickAway={accountMenuClose}>
                              <MenuList className={menuList}>
                                <MenuItem>
                                  <Link
                                    component={RouterLink}
                                    to={
                                      currentUser.isProvider
                                        ? '/admin/notifications'
                                        : '/patients'
                                    }
                                    className={menuItem}
                                  >
                                    {currentUser.isProvider
                                      ? 'Admin Portal'
                                      : 'Patient Portal'}
                                  </Link>
                                </MenuItem>

                                {!(
                                  currentUser.isProvider ||
                                  currentUser.isAdministrator
                                ) && (
                                  <MenuItem>
                                    <Link
                                      title="sign up a new user as your dependent"
                                      component={RouterLink}
                                      to={'/sign-up/dependent-patient-signup'}
                                      className={menuItem}
                                    >
                                      add child user
                                    </Link>
                                  </MenuItem>
                                )}

                                <MenuItem onClick={onLogout}>
                                  <span className={menuItem}>Logout</span>
                                </MenuItem>
                              </MenuList>
                            </ClickAwayListener>
                          </Paper>
                        </Grow>
                      )}
                    </Popper>
                  </div>
                </div>
              </Toolbar>
            </div>
          </AppBar>
          {currentUser && currentUser.patient && currentUser.patient.id ? (
            <Covid19Header />
          ) : null}
        </>
      )}
      {/* </CurrentPatientConsumer> */}
    </CurrentUserConsumer>
  );
}

const styles = () => ({
  navigation: {
    width: '100%',
    height: '80px',
    backgroundColor: 'rgba(255,255,255,0.85)',
    boxShadow: 'rgba(0, 0, 0, 0.118) 0px 1px 3px 0px',
    color: '#000000',
    alignItems: 'center',
    zIndex: '111',
    borderRight: '1px solid #DCDCDC',
    paddingLeft: '1em',
    '@media only screen and (max-width: 1024px)': {
      height: '140px',
      paddingTop: '2em',
      padding: '1.5em',
    },
  },
  toolbar: {
    width: '1080px',
    height: '80px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '@media only screen and (max-width: 1024px)': {
      flexDirection: 'column',
      justifyContent: 'center',
    },
  },
  logoImage: {
    width: '150px',
    height: '80px',
  },
  contents: {
    display: 'flex',
    alignItems: 'center',
    fontWeight: '500',
    '@media only screen and (max-width: 1024px)': {
      paddingTop: '10px',
      paddingLeft: '0',
    },
  },
  headerLink: {
    color: '#505D68',
    fontSize: '14px',
    paddingRight: '22px',
    textTransform: 'uppercase',
    textDecoration: 'none',
    position: 'relative',
    '&:hover': {
      color: '#2ea3f2',
      textDecoration: 'none',
    },
  },
  headerLinkWithIcon: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    paddingRight: '10px',
  },
  button: {
    backgroundColor: '#0277bd',
    color: 'white',
    '&:visited': {
      color: 'white',
    },
  },
  desktopOnlyLink: {
    '@media only screen and (max-width: 1023px)': {
      display: 'none',
    },
  },
  menuList: {
    borderTop: '4px solid #0277bd',
  },
  menuItem: {
    paddingRight: '3em',
    paddingLeft: '2em',
    textTransform: 'uppercase',
    fontSize: '0.8em',
    '&:hover': {
      textDecoration: 'none',
    },
  },
});

export default withStyles(styles)(PublicNavigation);
